module.exports = __webpack_public_path__ + "static/bani-winter-577058ed829c6fa20587251a240c5613.webp";